import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AdminService } from '../admin/admin.service';
import { MessagesService } from '../message/messages.service';

@Injectable({
  providedIn: 'root'
})
export class CheckLoginGuard implements CanActivate {

  constructor(private admin: AdminService, private router: Router, private msg: MessagesService) { }

  canActivate() {
    const loginDeets = this.admin.getLoginDeets();

    if (typeof loginDeets === 'object' && loginDeets !== null) {
      return true;
    } else {
      this.msg.warn('Unauthorized access, please login');
      this.router.navigate(['login']);
    }
    return false;
  }
}
